import { localeOption, updateLocaleOption } from 'primereact/api';

/**
 * PrimeReact names a row's selection checkbox with the label of the ACTION it picks for the next click
 * (`selected ? unselectRow : selectRow`), but its default strings read as states: an unselected row is announced
 * "Row Selected 1" and a selected one "Row Unselected 1". Same checkbox, same behaviour; only the two strings are
 * replaced with action wording. The header checkbox strings (state wording, correct) are left alone.
 */
export const applyRowSelectionAriaLabels = (select: string, deselect: string): void => {
  const aria = localeOption('aria', 'en') as Record<string, string> | undefined;
  if (!aria || (aria.selectRow === select && aria.unselectRow === deselect)) {
    return;
  }
  updateLocaleOption('aria', { ...aria, selectRow: select, unselectRow: deselect }, 'en');
};
